$(->
  $('#notification_test_input .submit').click ->
    $.ajax({
      url: "/admin/notifications/test",
      type: "POST",
      dataType: 'json',
      data: {
        account_id: $('#test_account_id').val(),
        test: $('#notification_test').val()
      },
      cache: false,
      success: (data)->
        $('#notification_test_input span.result').html(data.result + "")
    })
    false

  $(document).on 'click', '.notification .dismiss', (ev)->
    $.post('/manage/users/settings', { vtype: 'array', 'skip_notifications': $(this).closest('.notification').attr('id').replace('notification_','') })
    $(this).closest('.notification').remove()
    false

  setTimeout ->
    all_ints = $('#interrupts .modal')
    if all_ints.length > 0
      for interrupt, i in all_ints
        the_interrupt = $(interrupt)
        if i == (all_ints.length - 1)
          false
        else
          the_interrupt.find('.modal-footer').append('<button type="button" class="btn btn-primary">Next</button>')
          the_interrupt.find('.modal-footer button').click ->
            $(this).closest('.modal').modal('hide')
            $(this).closest('.modal').next().modal('show')
      all_ints.first().modal('show')
  , 100

  if $('#header_bar .notification').length > 0
    setInterval(->
      duplicate = $('#header_bar p.notification').length < 2
      if duplicate
        $('#header_bar .notification_wrapper').append($('#header_bar p.notification:first').clone())

      $('#header_bar .notification_wrapper').animate({ top: '-48px' }, 'slow', ->
        $('#header_bar .notification_wrapper p.notification:first').appendTo('#header_bar .notification_wrapper')
        $('#header_bar .notification_wrapper').css('top', '0px')
        if duplicate
          $('#header_bar p.notification:last').remove()
      )
    , 10000)

)
